import { render, staticRenderFns } from "./EnquiriesView.vue?vue&type=template&id=50f7bf5c&scoped=true&"
import script from "./EnquiriesView.vue?vue&type=script&lang=ts&"
export * from "./EnquiriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7bf5c",
  null
  
)

export default component.exports